"use client";

import { c as _c } from "react/compiler-runtime";
import RememeImage from "@/components/nft-image/RememeImage";
import Pagination from "@/components/pagination/Pagination";
import { printMemeReferences } from "@/components/rememes/RememePage";
import { RememeSort } from "@/components/rememes/Rememes";
import { publicEnv } from "@/config/env";
import { OPENSEA_STORE_FRONT_CONTRACT } from "@/constants/constants";
import type { DBResponse } from "@/entities/IDBResponse";
import type { NFT, Rememe } from "@/entities/INFT";
import { areEqualAddresses, formatAddress, numberWithCommas } from "@/helpers/Helpers";
import { fetchUrl } from "@/services/6529api";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { useCallback, useEffect, useRef, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import styles from "./TheMemes.module.scss";
const REMEMES_PAGE_SIZE = 20;
function getRememeName(rememe: Rememe) {
  const metadata = rememe.metadata as unknown;
  if (metadata !== null && typeof metadata === "object" && "name" in metadata && typeof metadata.name === "string" && metadata.name.trim()) {
    return metadata.name;
  }
  return `${formatAddress(rememe.contract)} #${rememe.id}`;
}
export function MemePageReferencesSubMenu(props) {
  const $ = _c(42);
  const [memeLabNftsLoaded, setMemeLabNftsLoaded] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [memeLabNfts, setMemeLabNfts] = useState(t0);
  const [rememesTotalResults, setRememesTotalResults] = useState(0);
  const [rememesPage, setRememesPage] = useState(1);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [rememes, setRememes] = useState(t1);
  const [showRememesSort, setShowRememesSort] = useState(false);
  const [rememesLoaded, setRememesLoaded] = useState(false);
  const rememesTarget = useRef(null);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [RememeSort.RANDOM, RememeSort.CREATED_ASC];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const rememeSorting = t2;
  const [selectedRememeSorting, setSelectedRememeSorting] = useState(RememeSort.RANDOM);
  let t3;
  if ($[3] !== rememesPage || $[4] !== selectedRememeSorting) {
    t3 = meme_id => {
      let sort = "";
      if (selectedRememeSorting === RememeSort.CREATED_ASC) {
        sort = "&sort=created_at&sort_direction=desc";
      }
      fetchUrl(`${publicEnv.API_ENDPOINT}/api/rememes?meme_id=${meme_id}&page_size=${REMEMES_PAGE_SIZE}&page=${rememesPage}${sort}`).then(response => {
        setRememesTotalResults(response.count);
        setRememes(response.data);
        setShowRememesSort(response.count > REMEMES_PAGE_SIZE);
        setRememesLoaded(true);
      }).catch(() => {
        setRememesTotalResults(0);
        setRememes([]);
        setShowRememesSort(false);
        setRememesLoaded(true);
      });
    };
    $[3] = rememesPage;
    $[4] = selectedRememeSorting;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const fetchRememes = t3;
  let t4;
  let t5;
  if ($[6] !== props.nft || $[7] !== props.show) {
    t4 = () => {
      if (props.show && props.nft) {
        fetchUrl(`${publicEnv.API_ENDPOINT}/api/nfts_memelab?sort_direction=asc&meme_id=${props.nft.id}`).then(response_0 => {
          setMemeLabNfts(response_0.data);
          setMemeLabNftsLoaded(true);
        }).catch(() => {
          setMemeLabNfts([]);
          setMemeLabNftsLoaded(true);
        });
      }
    };
    t5 = [props.show, props.nft];
    $[6] = props.nft;
    $[7] = props.show;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[10] !== fetchRememes || $[11] !== props.nft || $[12] !== props.show) {
    t6 = () => {
      if (props.show && props.nft) {
        fetchRememes(props.nft.id);
      }
    };
    t7 = [props.show, props.nft, fetchRememes];
    $[10] = fetchRememes;
    $[11] = props.nft;
    $[12] = props.show;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  if (!props.show) {
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <></>;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row className="pt-3"><Col><Image unoptimized={true} width="0" height="0" style={{
          width: "250px",
          height: "auto"
        }} src="/memelab.png" alt="memelab" /></Col></Row>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Row className="pt-4 pb-2"><Col>The Meme Lab is the lab for Meme Artists to release work that is related to The Meme Cards.</Col></Row>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== memeLabNfts || $[19] !== memeLabNftsLoaded) {
    t10 = printMemeReferences(memeLabNfts, "meme-lab", memeLabNftsLoaded, true);
    $[18] = memeLabNfts;
    $[19] = memeLabNftsLoaded;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h1 className="mb-0 pt-2"><Image unoptimized={true} width="0" height="0" style={{
        width: "250px",
        height: "auto",
        float: "left"
      }} src="/re-memes.png" alt="re-memes" /></h1>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== fetchRememes || $[23] !== props.nft || $[24] !== selectedRememeSorting || $[25] !== showRememesSort) {
    t12 = showRememesSort && <span className="d-flex align-items-center gap-2 pt-2"><Dropdown className={styles.rememesSortDropdown} drop="down-centered"><Dropdown.Toggle>Sort: {selectedRememeSorting}</Dropdown.Toggle><Dropdown.Menu>{rememeSorting.map(s => <Dropdown.Item key={`sorting-${s}`} onClick={() => {
            setRememesPage(1);
            setRememesTotalResults(0);
            setSelectedRememeSorting(s);
          }}>{s}</Dropdown.Item>)}</Dropdown.Menu></Dropdown>{selectedRememeSorting === RememeSort.RANDOM && <><FontAwesomeIcon icon={faRefresh} className={styles.buttonIcon} onClick={() => {
          if (props.nft) {
            fetchRememes(props.nft.id);
          }
        }} data-tooltip-id="refresh-rememes" /><Tooltip id="refresh-rememes" place="top" delayShow={250} style={{
          backgroundColor: "#f8f9fa",
          color: "#212529",
          padding: "4px 8px"
        }}>Refresh results</Tooltip></>}</span>;
    $[22] = fetchRememes;
    $[23] = props.nft;
    $[24] = selectedRememeSorting;
    $[25] = showRememesSort;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12) {
    t13 = <Row className="pt-3" ref={rememesTarget}><Col className="d-flex flex-wrap align-items-center justify-content-between">{t11}{t12}</Col></Row>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Row className="pt-4 pb-2"><Col>ReMemes are community-created and community-submitted NFTs inspired by the Meme Cards. They are not created or "authorized" by 6529 Collections.</Col></Row>;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== rememes.length || $[31] !== rememesLoaded) {
    t15 = rememesLoaded && rememes.length === 0 && <Row className="pt-2 pb-4"><Col>ReMemes that reference this NFT will appear here.</Col></Row>;
    $[30] = rememes.length;
    $[31] = rememesLoaded;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== rememes || $[34] !== rememesPage || $[35] !== rememesTotalResults) {
    t16 = rememes.length > 0 && <><Row className="py-2">{rememes.map(_temp)}</Row>{rememesTotalResults > REMEMES_PAGE_SIZE && <Row className="text-center pt-2 pb-3"><Pagination page={rememesPage} pageSize={REMEMES_PAGE_SIZE} totalResults={rememesTotalResults} setPage={function (newPage) {
          setRememesPage(newPage);
          if (rememesTarget.current) {
            rememesTarget.current.scrollIntoView({
              behavior: "smooth"
            });
          }
        }} /></Row>}</>;
    $[33] = rememes;
    $[34] = rememesPage;
    $[35] = rememesTotalResults;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t10 || $[38] !== t13 || $[39] !== t15 || $[40] !== t16) {
    t17 = <>{t8}{t9}{t10}{t13}{t14}{t15}{t16}</>;
    $[37] = t10;
    $[38] = t13;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
}
function _temp(rememe) {
  return <Col key={`${rememe.contract}-${rememe.id}`} className="py-3" xs={{
    span: 6
  }} sm={{
    span: 4
  }} md={{
    span: 3
  }} lg={{
    span: 3
  }}><Link href={`/rememes/${rememe.contract}/${rememe.id}`} className="decoration-none scale-hover"><Container fluid={true} className="no-padding"><Row><Col><RememeImage nft={rememe} animation={false} height={300} /></Col></Row><Row><Col><Container><Row><Col className="font-smaller font-color-h d-flex justify-content-center align-items-center">{areEqualAddresses(rememe.contract, OPENSEA_STORE_FRONT_CONTRACT) ? <>{rememe.contract_opensea_data.collectionName}</> : <>{rememe.contract_opensea_data.collectionName ? rememe.contract_opensea_data.collectionName : formatAddress(rememe.contract)}{" "}#{rememe.id}</>}{rememe.replicas.length > 1 && <> (x{numberWithCommas(rememe.replicas.length)})</>}</Col></Row><Row><Col className="d-flex justify-content-center align-items-center"><span className="text-center">{getRememeName(rememe)}</span></Col></Row></Container></Col></Row></Container></Link></Col>;
}